function getEnv(key) {
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return process.env[key];
}

const PLACETOPAY_INVALIDATE_URL = getEnv('REACT_APP_PLACETOPAY_INVALIDATE_URL');

export default async function invalidatePlaceToPayToken(body) {
  if (!PLACETOPAY_INVALIDATE_URL) {
    throw new Error('REACT_APP_PLACETOPAY_INVALIDATE_URL is not set.');
  }

  const response = await fetch(PLACETOPAY_INVALIDATE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });

  if (!response.ok) throw new Error(`Invalidate HTTP ${response.status}`);
  return response.json();
}